<template>
  <div class="my-exchange">
    <div class="my-exchange-content">
      <div class="exchange-info">
        <div class="info-box">
          <div class="info-flex">
            您正在使用<span class="active-color">{{userPrice.points}}积分</span><br />兑换<span class="active-color">{{itemData.vipName}}（{{userPrice.days}}天）</span>
          </div>
          <div>
            <img class="info-icon" src="../../assets/integral-icon/exchange-icon.png" alt="">
          </div>
        </div>
        <div class="user-row">
          <div class="user-name">当前账户</div>
          <div class="user-value">{{userInfo.userName}}</div>
        </div>
        <div class="user-row">
          <div class="user-name">手机号</div>
          <div class="user-value">{{userInfo.phoneNo}}</div>
        </div>
        <div class="tips-p">
          <div class="tips-title">请仔细阅读</div>
          <p>1、确认兑换后会员即刻生效，兑换后不能退回</p>
          <p>2、若已经购买过该等级会员将延长该会员时长。</p>
          <p>3、若有其他等级会员将优先使用其他等级会员。</p>
        </div>
      </div>
      <pi-button :type="loading ? 'loading' : 'primary'" block @click="confirmClick">立即兑换</pi-button>
    </div>
  </div>
</template>
<script>
import {  } from "vant";
import {
  getUserBaseInfo,
  purchaseUserVip
} from "../../common/api";

export default {
  name: "my-exchange",
  components: {
  },
  data() {
    return {
      userPrice: {},
      itemData: {},
      userInfo: {},
      loading: false
    }
  },
  mounted() {
    let details = this.$common.get('exchange-details');
    if(details){
      this.itemData = details.data;
      this.userPrice = details.child;
    }
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      getUserBaseInfo(null, true).then((response) => {
        if (
          response.status == this.$config.ajaxStatus &&
          response.data.length > 0
        ) {
          this.userInfo = response.data[0];
        }
      });
    },
    confirmClick(){
      this.$dialog
        .confirm({
          title: '提示',
          message: "确定使用"+this.userPrice.points+"积分兑换吗"+this.itemData.vipName+"（"+this.userPrice.days+"天）吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#14CC80",
          closeOnPopstate: true
        })
        .then(() => {
          this.purchaseUserVip()
        }).catch(error => {
          console.log(error);
        });
    },
    async purchaseUserVip(){
      this.loading = true;
      let ret = await purchaseUserVip({
        chargeUserPkId: this.$route.query.chargeUserPkId,
        // discountAmountType: this.itemData.discountAmountType
        points: this.userPrice.points,
        purchaseType: 1,
        purchaseWay: 2,
        vipDays: this.userPrice.days,
        vipLevel: this.itemData.vipLevel
      })
      if(ret.status == this.$config.ajaxStatus){
        this.$dialog
          .alert({
            title: '提示',
            message: '兑换成功',
            confirmButtonText: "确定",
            confirmButtonColor: "#14CC80",
            closeOnPopstate: true,
          })
          .then(() => {
            window.history.go(-2);
          })
          .catch(() => {});
        
      }else{
        this.$toast(ret.msg);
      }
      this.loading = false;
    }

  }
}
</script>
<style lang="less">
  .my-exchange{
    min-height: 100%;
    background-color: #F5F4F9;
    padding: 0.2rem;
    box-sizing: border-box;
    .my-exchange-content{
      background-color: #fff;
      border-radius: 0.12rem;
      padding: 0.4rem 0.2rem 0.5rem 0.2rem;
      .exchange-info{
        padding: 0 0.3rem;
        margin-bottom: 0.66rem;
        .info-box{
          display: flex;
        }
        .info-flex{
          flex: 1;
          font-size: 0.36rem;
          line-height: 0.5rem;
          padding-top: 0.1rem;
        }
        .active-color{
          color: #F95450;
        }
        .info-icon{
          margin-right: 0.05rem;
          width: 1.2rem;
          height: 1.2rem;
        }
        .user-row{
          margin-top: 0.2rem;
          font-size: 0.24rem;
          line-height: 0.33rem;
          display: flex;
        }
        .user-name{
          color: #999999;
          width: 1.56rem;
        }
        .user-value{
          color: #000;
          flex: 1;
        }
        .tips-p{
          margin-top: 0.4rem;
          font-size: 0.24rem;
          line-height: 0.33rem;
          color: #999999;
        }
        .tips-title{
          color: #000;
          margin-bottom: 0.1rem;
        }
      }
    }
  }
</style>